module.exports = __webpack_public_path__ + "img/rts_labeled_reduced.4d6295f0.png";